export enum ModalType {
  ApplicationsUpsellModal,
  AttachmentModal,
  AttachmentsUploader,
  CustomizedBlockedModal,
  BlockedModalFromModule,
  ContactInfoCallModal,
  DeleteAttachmentsModal,
  FiltersSelector,
  ImagesViewer,
  NotesModal,
  PersonalContactDetailsWarningModal,
  RenterDetailsModal,
  RenterMessagingModal,
  RenterProfileModal,
  ReportConversationModal,
  RequestRenterProfileModal,
  SavedReplyModal,
  SendApplicationConfirmationModal,
  SendMessageModal,
  TourSchedulingUpsellModal,
}
